export enum TrackedName {
    NON_PAYMENT_BUTTON = 'services_suspendus-payer-clic',
    NON_PAYMENT_VIEW = 'services_suspendus-payer-visionnage',
    NON_PAYMENT_PRESAR_BUTTON = 'services_suspendus_PRESAR-payer-clic',
    NON_PAYMENT_PRESAR_VIEW = 'services_suspendus_PRESAR-payer-visionnage',
    THEFT_LOSS_BUTTON = 'ligne_suspendue-reactive-clic',
    THEFT_LOSS_VIEW = 'ligne_suspendue-reactiver-visionnage',
    SERVICE_24H = 'service_24h',
    WHO_USES_IT = 'associer-a-un-profil',
    PROTECTEDHOUSE_V1 = 'maison_protegee_v1',
    TERMINATED = 'factures',
}
